import { FC } from 'react'

import { Avatar, Box, Text } from '@factorialco/deprecated-design-system'
import { PeopleChartEmployeeSidepanelBasicInfoFragment } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

type Props = {
  employee: PeopleChartEmployeeSidepanelBasicInfoFragment
  onTeamSelection: (teamId: string, openSidepanel: boolean) => void
  loading: boolean
}

const TeamsDetail: FC<Props> = ({ employee, onTeamSelection, loading }) => {
  return (
    <Box
      background="grey100"
      padding="s32"
      borderRadius={{
        bottomLeft: 'abs016',
        bottomRight: 'abs016',
      }}
      gap="s16"
    >
      <Text.Normal weight="bold" size="300">
        {i18n.t('teams.title')}
      </Text.Normal>
      <Box
        background="white"
        borderRadius={{ all: 'abs008' }}
        border={{
          all: {
            style: 'solid',
            width: 's1',
            color: 'grey400',
          },
        }}
      >
        {employee.memberships.map((team) => (
          <Box
            cursor="pointer"
            onClick={() => onTeamSelection(team.team?.id ?? '0', true)}
            flexDirection="row"
            key={team.id}
            alignItems="center"
            gap="s12"
            border={{
              bottom: {
                style: 'solid',
                width: 's1',
                color: 'grey400',
              },
            }}
            paddingTop="s16"
            paddingBottom="s16"
            paddingRight="s24"
            paddingLeft="s24"
          >
            <Avatar size="s32" label={team.team?.name || ''} url={team.team?.avatar || ''} />
            <Text.Normal size="200" weight="medium">
              {team.team?.name || ''}
            </Text.Normal>
          </Box>
        ))}
      </Box>
    </Box>
  )
}

export default TeamsDetail
